import { PlanSelection } from "@/components/setup/plan-selection";
import { SetupFormPaymentMethod } from "@/components/setup/setup-form-payment-method";
import DialogInviteBilling from "@/components/team/dialog-invite-billing";
import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { SubscriptionType } from "@shaarp/common";
import { useState } from "react";

export const SetupResubscriptionPaymentMethodPage = () => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();
  const { teamSelected } = useTeams();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const monthlyFloor = teamSelected?.initialProLicenseCountMonthly || 1;
  const annualFloor = teamSelected?.initialProLicenseCountAnnual || 1;
  const [subscriptionType, setSubscriptionType] = useState<SubscriptionType>(
    teamSelected?.defaultBillingFrequency || "monthly"
  );

  const [pendingProLicenseCount, setPendingProLicenseCount] = useState<number>(
    (teamSelected?.defaultBillingFrequency || "monthly") === "annual"
      ? annualFloor
      : monthlyFloor
  );

  return (
    <div className="space-y-7 w-full">
      <h1 className="text-2xl font-bold text-center text-primary">
        {t("setup.resubscription.paymentMethod.title")}
      </h1>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <PlanSelection
          defaultSubscriptionType={subscriptionType}
          defaultProLicenseCountMonthly={
            teamSelected?.initialProLicenseCountMonthly
          }
          defaultProLicenseCountAnnual={
            teamSelected?.initialProLicenseCountAnnual
          }
          onSubscriptionTypeChange={setSubscriptionType}
          onPendingProLicenseCountChange={setPendingProLicenseCount}
          hideTrialInfo={true}
        />

        <div className="space-y-4">
          <p className="text-sm">
            {t("setup.resubscription.paymentMethod.payment.instruction")}
          </p>

          <p className="text-sm">
            {t("setup.resubscription.paymentMethod.payment.alternate")}
          </p>
          <div className="text-center">
            <Button
              onClick={() => setIsDialogOpen(true)}
              variant="outline"
            >
              {t("setup.resubscription.paymentMethod.payment.inviteButton")}
            </Button>
          </div>

          <SetupFormPaymentMethod
            onCompleted={nextStep}
            subscriptionType={subscriptionType}
            pendingProLicenseCount={pendingProLicenseCount}
          />
        </div>
      </div>

      {isDialogOpen && (
        <DialogInviteBilling
          onClose={() => setIsDialogOpen(false)}
          onCompleted={() => setIsDialogOpen(false)}
          pendingProLicenseCount={pendingProLicenseCount}
          subscriptionType={subscriptionType}
        />
      )}
    </div>
  );
};
